var _path, _path2, _path3, _path4;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgBag(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 36,
    height: 37,
    viewBox: "0 0 36 37",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M32 8.5H26V4.5C26 2.291 24.209 0.5 22 0.5H14C11.791 0.5 10 2.291 10 4.5V8.5H4C1.791 8.5 0 10.291 0 12.5V32.5C0 34.709 1.791 36.5 4 36.5H32C34.209 36.5 36 34.709 36 32.5V12.5C36 10.291 34.209 8.5 32 8.5ZM12 6.5C12 5.396 12.896 4.5 14 4.5H22C23.104 4.5 24 5.396 24 6.5V8.5H12V6.5Z",
    fill: "#9A4E1C"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M36 20.5C36 22.709 34.209 24.5 32 24.5H4C1.791 24.5 0 22.709 0 20.5V12.5C0 10.291 1.791 8.5 4 8.5H32C34.209 8.5 36 10.291 36 12.5V20.5Z",
    fill: "#662113"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M36 18.5C36 20.709 34.209 22.5 32 22.5H4C1.791 22.5 0 20.709 0 18.5V12.5C0 10.291 1.791 8.5 4 8.5H32C34.209 8.5 36 10.291 36 12.5V18.5Z",
    fill: "#9A4E1C"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M22 18.5C22 19.604 21.104 20.5 20 20.5H16C14.896 20.5 14 19.604 14 18.5C14 17.396 14.896 16.5 16 16.5H20C21.104 16.5 22 17.396 22 18.5Z",
    fill: "#CCD6DD"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBag);
export default __webpack_public_path__ + "static/media/bag.4e75c5d68a64db41c35868f5e3db0e76.svg";
export { ForwardRef as ReactComponent };